import React, { Component } from 'react'
import { renderToString } from 'react-dom/server'
import { money, makeid } from '../../utils/helpers'
import { makeRequest, makeProduct } from '../../utils/Storefront.js'

class ProductTile extends Component {
  constructor(props) {
    super(props)
    let thirdValue = props.json.options_by_name?.Length?.option?.values[0]
    if (!props.json.siblings || props.json.siblings.length == 0) props.json.siblings = [props.json]
    if (thirdValue && props.json.variants.filter((v) => v.available && v.options.includes(thirdValue)).length == 0) {
      const secondThirdValue = props.json.options_by_name?.Length?.option?.values[1]
      if (
        secondThirdValue &&
        props.json.variants.filter((v) => v.available && v.options.includes(secondThirdValue)).length > 0
      )
        thirdValue = secondThirdValue
    }
    const json = this.adjustJson(props.json, props.realPrice, props.realCompPrice, thirdValue)
    const currentProduct = this.getCurrentProductByColor(json, json.siblings, props.preselectedColors)
    let swatchIndex = undefined
    json.siblings?.forEach((sibling, index) => {
      if (sibling.id == currentProduct?.id) swatchIndex = index
    })

    this.state = {
      data: json,
      currentProduct: currentProduct,
      lazyload: props.lazyload == 'true' ? true : false,
      search: props.search == 'true' ? true : false,
      columnsDesktop: JSON.parse(props.columnsDesktop),
      columnsTablet: JSON.parse(props.columnsTablet),
      columnsMobile: JSON.parse(props.columnsMobile),
      addon: props.addon == 'true' ? true : false,
      showcase: props.showcase == 'true' ? true : false,
      flatlay: props.flatlay == 'true' ? true : false,
      multiple: props.multiple == 'true' ? true : false,
      desktopWidths: [
        [3200, 5400],
        [2480, 4200],
        [1920, 3100],
        [1440, 2400],
        [1280, 2000],
      ],
      tabletWidths: [
        [1100, 1800],
        [1024, 1600],
        [900, 1400],
        [768, 1200],
      ],
      mobileWidths: [
        [700, 1024],
        [600, 840],
        [480, 720],
        [400, 600],
        [300, 500],
      ],
      sizeOptionsOpen: false,
      selectedVariant:
        typeof props.selectedVariantId == 'undefined' || props.selectedVariantId == '' || !props.selectedVariantId
          ? null
          : json.variants.filter((variant) => variant.id == parseInt(props.selectedVariantId))[0],
      wishlistPage: location.href.includes('/pages/wishlist'),
      hasFlatlayImage: currentProduct?.images.filter((image) => image.preview_image.src.includes('flatlay')).length > 0,
      tileKey: makeid(5),
      swatchIndex: swatchIndex,
      thirdValue: thirdValue,
      // excludeSizes: ['Small', 'Med', 'Large', 'XLarge', 'XSmall', 'SM', 'MD', 'LG', 'X-L', 'ST', 'XST'],
      collectionLoaded: json.collectionLoaded !== false,
      plpIndex: props.plpIndex,
    }

    this.swiperRef = React.createRef()

    this.learnqProduct(currentProduct)
  }

  adjustJson(propJson, realPrice, realCompPrice, thirdValue = null) {
    const newJson = propJson
    newJson.price = realPrice && realPrice > 0 ? realPrice : newJson.price
    newJson.comparePrice = realCompPrice && realCompPrice > 0 ? realCompPrice : newJson.comparePrice
    if (thirdValue) {
      newJson.variants = propJson.variants.filter((variant) => variant.options.includes(thirdValue))
    }
    newJson.siblings?.forEach((sibling) => {
      sibling.price = realPrice && realPrice > 0 ? realPrice : sibling.price
      sibling.comparePrice = realCompPrice && realCompPrice > 0 ? realCompPrice : sibling.comparePrice
      if (thirdValue) {
        sibling.variants = sibling.variants.filter((variant) => variant.options.includes(thirdValue))
      }
    })
    return newJson
  }

  getCurrentProductByColor(current, siblings, preselectedColors) {
    const colors = preselectedColors.split(',').filter((n) => n)
    let selectedProduct = current
    if (colors.length > 0) {
      let temp = siblings?.filter(
        (sibling) =>
          sibling.options_by_name.Colour &&
          colors.filter(
            (color) =>
              window.colorSwatches[sibling.options_by_name.Colour.option.values[0]] &&
              window.colorSwatches[sibling.options_by_name.Colour.option.values[0]].includes(color),
          ).length > 0,
      )[0]
      if (temp) selectedProduct = temp
    }
    return selectedProduct
  }

  learnqProduct(product) {
    window[`learnqProductItem_${product.id}`] = {
      Name: product.title,
      ProductID: product.id,
      Categories: product.categories,
      ImageURL: `https:${product.featured_image?.src}&width=600&height=600&crop=center`,
      URL: `${location.origin}${product.url}`,
      Brand: product.vendor,
      Price: money(product.price),
      CompareAtPrice: product.comparePrice && product.comparePrice > product.price ? money(product.comparePrice) : '$0',
    }
  }

  checkImageRender() {
    const nextCta = document.querySelector(`.plp-cta [data-cta-index="${this.state.plpIndex + 1}"]`)
    if (this.state.plpIndex == 1) {
      this.swiperRef.current.classList.remove('!opacity-0')
      const prevCta = document.querySelector(`.plp-cta [data-cta-index="${this.state.plpIndex}"]`)
      if (prevCta) prevCta.classList.remove('!opacity-0')
      if (nextCta) nextCta.classList.remove('!opacity-0')
    } else {
      const prevIndex = this.state.plpIndex - 1
      const preElement = document.querySelector(`[data-plp-index="${prevIndex}"] [data-tile-swiper]`)

      if (preElement) {
        const timer = setInterval(() => {
          if (!preElement.classList.contains('!opacity-0')) {
            clearInterval(timer)
            this.swiperRef.current.classList.remove('!opacity-0')
            if (nextCta) nextCta.classList.remove('!opacity-0')
          }
        }, 50)
      }
      const ctaElements = document.querySelectorAll(`.plp-cta [data-cta-index="${this.state.plpIndex}"]`)
      ctaElements.forEach((ctaElement) => ctaElement.classList.remove('!opacity-0'))
    }
  }

  imageUrl(url, width) {
    return url
      .replace('.jpg?', `.jpg?width=${width}&`)
      .replace('.png?', `.png?width=${width}&`)
      .replace('.webp?', `.webp?width=${width}&`)
  }

  getPicture(image, lazyload = true, sizeClass = 'object-cover') {
    const newSizeClass = image.preview_image.src.includes('flatlay') ? 'object-contain' : sizeClass
    return (
      <picture>
        {this.state.desktopWidths.map((desktopWidth, index) => (
          <source
            media={`(min-width:${desktopWidth[0]}px)`}
            srcSet={this.imageUrl(image.preview_image.src, Math.round(desktopWidth[1] / this.state.columnsDesktop))}
            key={`desktop-${this.state.data.id}-${index}`}
          />
        ))}
        {this.state.tabletWidths.map((tabletWidth, index) => (
          <source
            media={`(min-width:${tabletWidth[0]}px)`}
            srcSet={this.imageUrl(image.preview_image.src, Math.round(tabletWidth[1] / this.state.columnsTablet))}
            key={`tablet-${this.state.data.id}-${index}`}
          />
        ))}
        {this.state.mobileWidths.map((mobileWidth, index) => (
          <source
            media={`(min-width:${mobileWidth[0]}px)`}
            srcSet={this.imageUrl(image.preview_image.src, Math.round(mobileWidth[1] / this.state.columnsMobile))}
            key={`mobile-${this.state.data.id}-${index}`}
          />
        ))}
        <img
          src={this.imageUrl(
            image.preview_image.src,
            Math.round(this.state.mobileWidths[this.state.mobileWidths.length - 1][1] / this.state.columnsMobile),
          )}
          className={`w-full h-full object-center block ${newSizeClass}`}
          fetchpriority={lazyload ? 'auto' : 'high'}
          loading={lazyload ? 'lazy' : 'eager'}
          alt={image.alt}
          width={image.width}
          height={image.height}
          onLoad={(e) => this.checkImageRender()}
        />
      </picture>
    )
  }

  productUrl(handle) {
    return `${this.state.data.collectionHandle ? '/collections/' + this.state.data.collectionHandle : ''}/products/${handle}`
  }

  getColor(product) {
    return product.options_by_name?.Colour && product.options_by_name?.Colour.option.values.length > 0
      ? product.options_by_name?.Colour.option.values[0]
      : ''
  }

  updateStates(product) {
    this.setState({
      id: product.id,
      title: product.title,
      price: product.price,
      firstImage: product.images[0],
      secondImage: product.images.length > 1 ? product.images[1] : product.images[0],
      currentColor:
        product.options_by_name?.Colour && product.options_by_name?.Colour.option.values.length > 0
          ? product.options_by_name?.Colour.option.values[0]
          : '',
      handle: product.handle,
    })
  }

  isSizeVariantAvailable(size) {
    const sizeVariant = this.state.currentProduct.variants.filter((variant) => variant.options.includes(size))[0]
    return sizeVariant?.available
  }

  addToCart(e) {
    e.preventDefault()
    if (this.state.selectedVariant && this.state.selectedVariant.available) {
      const properties = {}
      const tagPart = this.state.currentProduct?.tags?.filter((tag) => tag.includes('takeoff'))[0]
      if (
        (!!this.state.currentProduct?.comparePrice &&
          this.state.currentProduct?.price < this.state.currentProduct?.comparePrice) ||
        !!tagPart
      ) {
        properties['_final_sale'] = 'true'
      }

      if (!!tagPart) {
        properties['_tag_part'] = tagPart
      }
      window.addLineItems(
        (cart) => {
          initMiniCart(cart)
          window.openCart()
          if (
            typeof window[`learnqProductItem_${this.state.currentProduct.id}`] != 'undefined' &&
            window[`learnqProductItem_${this.state.currentProduct.id}`]
          ) {
            var _learnq = _learnq || []
            _learnq.push(['track', 'Added to Cart', window[`learnqProductItem_${this.state.currentProduct.id}`]])
          }
          setTimeout(() => {
            this.setState({ selectedVariant: null })
          }, 300)
        },
        [{ id: this.state.selectedVariant.id, quantity: 1, properties }],
        e.target.closest('.plp-swatches')
          ? e.target.closest('.plp-swatches').querySelector('.plp-swatch-atc')
          : e.target,
      )
    }
  }
  setVariant(size) {
    this.setState({
      selectedVariant: this.state.currentProduct.variants.filter((variant) => variant.options.includes(size))[0],
    })
    setTimeout(() => {
      _swat.initializeActionButtons('#MainContent', '.plp-wishlist-btn')
    }, 500)
  }

  productTitle() {
    // Only show title if collection data is loaded and we have a groupTitle
    if (!this.state.collectionLoaded || !this.state.data.groupTitle) {
      return '' // Return empty string to prevent flickering
    }
    let title = this.state.data.groupTitle
    return title.replace(' - sale', '').replace(' - Sale', '').replace(' - SALE', '')
  }

  initSlider() {
    if (window.innerWidth >= 1024) {
      if (typeof this.swiperRef.current.swiper != 'undefined' && this.swiperRef.current.swiper)
        this.swiperRef.current.swiper.destroy(true, true)
    } else {
      if (typeof this.swiperRef.current.swiper == 'undefined' || !this.swiperRef.current.swiper) {
        new Swiper(this.swiperRef.current, {
          speed: 300,
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
          },
          on: {
            activeIndexChange: (swiper) => {
              setTimeout(() => {
                const activeSlide = swiper.el.querySelector('.swiper-slide-active')
                if (!activeSlide.querySelector('img')) {
                  const image = JSON.parse(activeSlide.dataset.image)
                  activeSlide.innerHTML = `${renderToString(this.getPicture(image, false))}`
                }
              }, 200)
            },
          },
        })
      }
    }
  }

  componentDidMount() {
    this.initSlider()
    window.addEventListener('resize', () => {
      this.initSlider()
    })

    if (typeof this.state.collectionLoaded == 'undefined' || !this.state.collectionLoaded) {
      const query = `
        {
          product(id: "gid://shopify/Product/${this.state.data.id}") {
            ${window.window.productGroupResponse}
          }
        }
      `
      makeRequest((res) => {
        const group = res?.data?.product?.group?.reference
        const collections = res?.data?.product?.collections?.edges
        let swatchIndex = undefined
        const siblings = group?.siblings?.references?.edges
          ?.filter((edge) => edge.node.onlineStoreUrl)
          .map((edge) => makeProduct(edge.node, false))
        siblings?.forEach((sibling, index) => {
          if (sibling.id == this.state.currentProduct?.id) swatchIndex = index
        })
        this.setState({
          collectionLoaded: true,
          data: Object.assign(this.state.data, {
            groupTitle: group?.groupTitle?.value,
            siblings: siblings,
            breadcrumb: { title: group?.breadcrumb?.reference?.title },
          }),
          swatchIndex: swatchIndex,
        })
        if (window[`learnqProductItem_${this.state.currentProduct.id}`])
          window[`learnqProductItem_${this.state.currentProduct.id}`]['Categories'] = collections?.map(
            (edge) => edge.node.title,
          )
      }, query)
    }
  }

  render() {
    return (
      <div className={`product-tile ${this.state.showcase ? 'flex gap-3 lg:gap-6' : ''}`}>
        <div className={`product-tile--images w-full pb-[133%] relative group ${this.state.showcase ? '' : 'mb-3'}`}>
          <a
            className={`absolute block inset-0 overflow-hidden group`}
            href={this.productUrl(this.state.currentProduct.handle)}
            aria-label={this.state.currentProduct.title}
            target={this.state.showcase ? '_blank' : '_self'}
          >
            <div
              className={`h-full w-full ${this.state.plpIndex ? '!opacity-0 transition-opacity ease-in-outt duration-300' : ''}`}
              data-tile-swiper
              ref={this.swiperRef}
            >
              <div className={`swiper-wrapper h-full`}>
                {this.state.addon || this.state.showcase || this.state.flatlay ? (
                  <>
                    {this.state.currentProduct.images.map((image, index) =>
                      (this.state.hasFlatlayImage && image.preview_image.src.includes('flatlay')) ||
                      (!this.state.hasFlatlayImage && index == 0) ? (
                        <div
                          className="swiper-slide"
                          key={`product-image-${this.state.tileKey}-${this.state.currentProduct.id}-${index}`}
                        >
                          {this.getPicture(
                            image,
                            this.state.lazyload,
                            this.state.hasFlatlayImage ? 'object-contain' : 'object-cover',
                          )}
                        </div>
                      ) : null,
                    )}
                    {this.state.currentProduct.images.map((image, index) =>
                      (this.state.hasFlatlayImage && image.preview_image.src.includes('flatlay')) ||
                      (!this.state.hasFlatlayImage && index == 0) ? null : (
                        <div
                          className="swiper-slide"
                          key={`product-image-${this.state.tileKey}-${this.state.currentProduct.id}-${index}`}
                          data-image={JSON.stringify(image)}
                        >
                          {index < 2 ? this.getPicture(image, index == 1 ? false : true) : null}
                        </div>
                      ),
                    )}
                  </>
                ) : (
                  this.state.currentProduct.images.map((image, index) => (
                    <div
                      className="swiper-slide"
                      key={`product-image-${this.state.tileKey}-${this.state.currentProduct.id}-${index}`}
                      data-image={JSON.stringify(image)}
                    >
                      {index < 2
                        ? this.getPicture(image, index == 0 ? this.state.lazyload : index == 1 ? false : true)
                        : null}
                    </div>
                  ))
                )}
                {this.state.currentProduct.images.length == 1 && (
                  <div
                    className="swiper-slide"
                    key={`product-image-${this.state.tileKey}-${this.state.currentProduct.id}-1`}
                  >
                    {this.getPicture(this.state.currentProduct.images[0])}
                  </div>
                )}
              </div>
              <div className="swiper-pagination !h-0.5 !top-auto !bottom-0"></div>
            </div>
            {!this.state.showcase &&
              !this.state.flatlay &&
              this.state.multiple &&
              this.state.currentProduct.options_by_name.Size && (
                <div
                  className={`plp-swatches z-1 hidden group-hover:lg:flex flex-wrap gap-y-3 gap-x-1 items-center justify-between absolute bottom-3 text-black bg-white rounded-[2rem] lg:rounded-xl xl:rounded-[2rem] py-2.5 ${this.state.multiple ? 'inset-x-3 px-4 lg:px-2 xl:px-4' : 'inset-x-1 px-3'} ${this.state.data.tags.includes('Surfboard') ? '!hidden' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                  }}
                >
                  {this.state.multiple && (
                    <div
                      className="text-xs leading-4 plp-swatch-atc"
                      onMouseEnter={(e) => {
                        if (!this.state.selectedVariant) e.target.innerHTML = 'Select Size'
                      }}
                      onMouseLeave={(e) => {
                        if (!this.state.selectedVariant) e.target.innerHTML = 'Quick Buy'
                      }}
                    >
                      Quick Buy
                    </div>
                  )}
                  <div
                    className={`plp-swatch flex items-center justify-between flex-wrap ${this.state.multiple ? 'gap-y-4 gap-x-4 lg:gap-x-2 xl:gap-x-4' : 'gap-3 w-full'}`}
                  >
                    {this.state.currentProduct.options_by_name.Size.option.values.map((value, index) =>
                      this.state.data.variants.filter((v) => v.options[1] && v.options[1] == value).length > 0 ? (
                        <span
                          className={`cursor-pointer leading-4 relative font-medium after:absolute after:-inset-x-1.5 after:-inset-y-1 after:border after:rounded-full after:hidden after:content-[''] 
                        ${this.isSizeVariantAvailable(value) ? '' : 'opacity-20'}
                        ${this.state.multiple ? 'text-base' : 'text-sm'} 
                        ${this.state.selectedVariant && this.state.selectedVariant.options.includes(value) ? `after:border-lof-red after:!block` : `hover:after:border-black hover:after:block`}
                        ${value == 'XS' ? '-order-1' : ''}
                        `}
                          key={`quick-buy-${this.state.data.id}-${this.state.currentProduct.id}-${index}`}
                          onClick={(e) => {
                            this.setVariant(value)
                            setTimeout(() => {
                              this.addToCart(e)
                            }, 100)
                          }}
                        >
                          {value}
                        </span>
                      ) : null,
                    )}
                  </div>
                </div>
              )}
            <div className="product-tile--tags absolute left-3 top-3 gap-3 font-bold text-xs leading-4 text-black hidden group-hover:flex z-1">
              {this.state.data.breadcrumb && !this.state.showcase && (
                <span className="capitalize">{this.state.data.breadcrumb.title}</span>
              )}
            </div>
          </a>
          {!this.state.wishlistPage && !this.state.showcase && (
            <button
              className={`plp-wishlist-btn !z-2 !absolute top-3 right-3 swym-button swym-add-to-wishlist-view-product product_${this.state.currentProduct.id} !visible !opacity-100 !hidden group-hover:!inline-flex`}
              data-with-epi={true}
              data-swaction="addToWishlist"
              data-product-id={this.state.currentProduct.id}
              data-variant-id={this.state.selectedVariant?.id || this.state.currentProduct.defaultVariant}
              data-product-url={`https://${location.host}${this.state.currentProduct.url}`}
            >
              <span className="text-white" dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-heart'] }} />
              <span
                className="text-white"
                dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-heart-filled'] }}
              />
              <span className="visually-hidden">Add to wishlist</span>
            </button>
          )}
          {this.state.wishlistPage && (
            <button
              className="w-4 h-4 !z-2 inline-flex items-center justify-center absolute top-2.5 right-2.5 text-accent-1"
              dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-close'] }}
              data-wishlist-remove={this.state.selectedVariant?.id || this.state.currentProduct.defaultVariant}
            />
          )}
          {/* {
            this.state.currentProduct.tags.map(tag => {
              return tag.includes('takeoff') && tag.includes(':') ?
              <div className='text-xs leading-4 font-bold hidden lg:inline-block px-2 py-1 z-1 rounded-xl absolute top-3 right-3 border' style={{color: tag.split(':')[2], backgroundColor: tag.split(':')[3], borderColor: tag.split(':')[2]}}>
                { tag.split(':')[1] }
              </div> : ''
            })
          } */}
        </div>
        <div className={`product-tile--content text-xs leading-4 ${this.state.showcase ? 'grow' : 'px-2 lg:px-3'}`}>
          <a
            className="flex items-center justify-between mb-0.5"
            href={this.productUrl(this.state.currentProduct.handle)}
            target={this.state.showcase ? '_blank' : '_self'}
          >
            <h3 className="font-medium text-left">{this.productTitle()}</h3>
            {this.state.multiple && (
              <div className="ml-4" data-price>
                {this.state.currentProduct.comparePrice > this.state.currentProduct.price ? (
                  <span>
                    <span className="line-through inline-block mr-3">
                      {money(this.state.currentProduct.comparePrice)}
                    </span>
                    <span className="text-accent-1">{money(this.state.currentProduct.price)}</span>
                  </span>
                ) : (
                  money(this.state.currentProduct.price)
                )}
              </div>
            )}
          </a>
          {!this.state.search && (
            <div className={``}>
              <div className={`${this.state.showcase ? 'block' : 'flex'} items-center justify-between`}>
                <div className={`text-left ${this.state.showcase ? 'mb-3.5' : ''}`} data-color>
                  {this.getColor(this.state.currentProduct)}
                </div>
                {this.state.multiple && (
                  <div
                    className={`${this.state.showcase ? 'flex' : 'hidden lg:flex ml-3'} items-center h-4 gap-2`}
                    data-swatches
                  >
                    {!isNaN(this.state.swatchIndex) && (
                      <button
                        className={`swatch--${this.state.data.siblings[this.state.swatchIndex].colorHandle} ${this.state.data.siblings[this.state.swatchIndex].id == this.state.currentProduct.id ? 'swatch--active' : ''} after:hidden w-[0.5625rem] h-[0.5625rem] rounded-full   relative after:content-[''] after:absolute after:inset-[-0.1875rem] after:rounded-full after:border after:border-black`}
                        title={this.getColor(this.state.data.siblings[this.state.swatchIndex])}
                        onClick={() => {
                          this.setState({
                            currentProduct: this.state.data.siblings[this.state.swatchIndex],
                            selectedVariant: null,
                            hasFlatlayImage:
                              this.state.data.siblings[this.state.swatchIndex].images.filter((image) =>
                                image.preview_image.src.includes('flatlay'),
                              ).length > 0,
                          })
                          this.learnqProduct(this.state.data.siblings[this.state.swatchIndex])
                          setTimeout(() => {
                            _swat.initializeActionButtons('#MainContent', '.plp-wishlist-btn')
                          }, 500)
                        }}
                      >
                        <span className="visually-hidden">
                          {this.getColor(this.state.data.siblings[this.state.swatchIndex])}
                        </span>
                        {this.state.data.siblings[this.state.swatchIndex].images.length > 0 && (
                          <span className="hidden">
                            <img
                              src={this.imageUrl(
                                this.state.data.siblings[this.state.swatchIndex].images[0].preview_image.src,
                                1,
                              )}
                              fetchpriority="high"
                            />
                          </span>
                        )}
                      </button>
                    )}
                    {this.state.data?.siblings
                      ?.slice(0, !isNaN(this.state.swatchIndex) && this.state.swatchIndex < 6 ? 6 : 5)
                      .map((sibling, index) =>
                        sibling.id == this.state.data.id ||
                        (!isNaN(this.state.swatchIndex) && this.state.swatchIndex == index) ? null : (
                          <button
                            className={`swatch--${sibling.colorHandle} ${sibling.id == this.state.currentProduct.id ? 'swatch--active' : ''} after:hidden w-[0.5625rem] h-[0.5625rem] rounded-full   relative after:content-[''] after:absolute after:inset-[-0.1875rem] after:rounded-full after:border after:border-black`}
                            title={this.getColor(sibling)}
                            key={`product-swatch-${this.state.data.id}-${sibling.id}`}
                            onClick={() => {
                              this.setState({
                                currentProduct: sibling,
                                selectedVariant: null,
                                hasFlatlayImage:
                                  sibling.images.filter((image) => image.preview_image.src.includes('flatlay')).length >
                                  0,
                              })
                              this.learnqProduct(sibling)
                              setTimeout(() => {
                                _swat.initializeActionButtons('#MainContent', '.plp-wishlist-btn')
                              }, 500)
                            }}
                          >
                            <span className="visually-hidden">{this.getColor(sibling)}</span>
                            {sibling.images.length > 0 && (
                              <span className="hidden">
                                <img src={this.imageUrl(sibling.images[0].preview_image.src, 1)} fetchpriority="high" />
                              </span>
                            )}
                          </button>
                        ),
                      )}
                    {this.state.data.siblings && this.state.data.siblings?.length > 6 ? (
                      <div className="ml-2.5">{`+${this.state.data.siblings?.length - 6}`}</div>
                    ) : null}
                  </div>
                )}
                {this.state.multiple && !this.state.showcase & (this.state.data.siblings?.length > 1) ? (
                  <div className="inline-block lg:hidden ml-2.5 min-w-[4.125rem]">{`+${this.state.data.siblings?.length - 1} Colours`}</div>
                ) : null}
              </div>
              {(this.state.showcase || this.state.flatlay) && this.state.multiple && (
                <div
                  className={`mt-6 ${this.state.showcase ? 'grid grid-cols-1' : ''} ${this.state.flatlay ? 'flex items-center justify-between' : ''} gap-2.5 flatlay-actions`}
                >
                  {this.state.currentProduct.available && (
                    <>
                      <button
                        className={`${this.state.showcase ? 'h-8' : ''} ${this.state.flatlay ? 'h-9 w-16 lg:w-20' : ''} rounded-[1.25rem] px-3 flex items-center justify-between text-black border border-black font-medium text-sm leading-4 relative`}
                        onClick={() => this.setState({ sizeOptionsOpen: !this.state.sizeOptionsOpen })}
                      >
                        {this.state.selectedVariant ? this.state.selectedVariant.options[1] : 'Size'}
                        <span dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-plus'] }} />
                        {this.state.sizeOptionsOpen && (
                          <ul className="product-tile--sizes__dropdown p-3 absolute z-1 bottom-[calc(100%+0.25rem)] -left-px -right-px grid grid-cols-1 gap-2 bg-white border border-black">
                            {this.state.currentProduct.options_by_name.Size.option.values.map((value, index) =>
                              this.state.data.variants.filter((v) => v.options[1] && v.options[1] == value).length >
                              0 ? (
                                <li
                                  className={`text-left text-base leading-4 font-medium ${this.isSizeVariantAvailable(value) ? '' : 'opacity-20'}`}
                                  key={`showcase-quick-buy-${this.state.data.id}-${this.state.currentProduct.id}-${index}`}
                                  onClick={() => {
                                    if (this.isSizeVariantAvailable(value)) this.setVariant(value)
                                  }}
                                >
                                  {value}
                                </li>
                              ) : null,
                            )}
                          </ul>
                        )}
                      </button>
                      <button
                        className={`${this.state.showcase ? 'h-8' : ''} ${this.state.flatlay ? `h-9 w-[calc(100%-4.5rem)] lg:w-[calc(100%-5.625rem)]` : ''} button button--primary inline-flex items-center justify-center !py-0 !px-1`}
                        onClick={(e) => {
                          this.addToCart(e)
                        }}
                        onMouseEnter={(e) => {
                          if (!this.state.selectedVariant) e.target.innerHTML = 'Select Size'
                        }}
                        onMouseLeave={(e) => {
                          if (!this.state.selectedVariant) e.target.innerHTML = 'Add to Bag'
                        }}
                      >
                        Add to Bag
                      </button>
                    </>
                  )}
                  {!this.state.currentProduct.available && (
                    <button className="button button--secondary !opacity-50 w-full h-9 !py-0" disabled>
                      Sold Out
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
          {!this.state.showcase &&
            this.state.currentProduct.tags.map((tag) => {
              return tag.includes('label:') ? (
                <div className="text-xs leading-4 font-bold mt-0.5 text-left text-lof-red">{tag.split(':')[1]}</div>
              ) : (
                ''
              )
            })}
        </div>
      </div>
    )
  }
}
export default ProductTile
